<template>
  <coverageAndThomaticReport type="program" label="programs_report" />
</template>
<script>
import coverageAndThomaticReport from "./coverageAndThomaticReport";
export default {
  components: { coverageAndThomaticReport }
};
</script>
